import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { FundingRequestEligibilityVM } from "@shared-kernel/application/ports/student/student-repository";

export const adminRetrieveFundingRequestEligibility = createAsyncThunk<
  FundingRequestEligibilityVM,
  string,
  { extra: Partial<Dependencies> }
>("fundingRequests/adminRetrieveFundingRequestEligibility", async (studentId: string, { extra: { adminRepository } }) => {
  return adminRepository!.adminFundingRequestEligibility(studentId);
});

export const adminResetRetrieveFundingRequestEligibility = createAction("fundingRequests/adminResetRetrieveFundingRequestEligibility");
